import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { AppState } from '../state/app-state';
import { StateService } from '../state/state.service';

@Pipe({
  name: 'state',
  standalone: false,
})
export class StatePipe implements PipeTransform {
  constructor(private state: StateService) {}
  transform(key: keyof AppState): Observable<any> {
    const res = this.state.state$.pipe(
      debounceTime(1),
      map((state) => this.getPath(key, state)),
      distinctUntilChanged(),
    );
    return res;
  }

  private getPath(path: string | null, obj: any): any {
    if (path) {
      const parts = path.split('.');
      if (parts.length > 1) {
        // recursion, ie. get state.something.somethingElse
        return this.getPath(
          parts.slice(1, parts.length).join('.'),
          obj[parts[0]],
        );
      }
      return (obj && obj[path]) ?? null;
    }
    return obj;
  }
}
